'use strict';

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _socketIoClient = require('socket.io-client');

var _socketIoClient2 = _interopRequireDefault(_socketIoClient);

var _transportJsonrpc = require('../transport/jsonrpc');

var _transportJsonrpc2 = _interopRequireDefault(_transportJsonrpc);

var _transportWebsockets = require('../transport/websockets');

var _transportWebsockets2 = _interopRequireDefault(_transportWebsockets);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _reactProgress2 = require("react-progress-2");

var _reactProgress22 = _interopRequireDefault(_reactProgress2);

var _EventEmitter = require("../EventEmitter");

var _EventEmitter2 = _interopRequireDefault(_EventEmitter);

function initSocket() {
	var ws = 'WebSocket' in window && window.WebSocket.CLOSING === 2;
	var socket = undefined;
	if (ws) {
		socket = _socketIoClient2['default']('http://reactis.vyvoj.ondrejnovak.eu:3000');
		socket.on('connect', function () {
			console.log('connect');
			socket.emit('init', { text: 'hello' });
		});
		socket.on('time', function (msg) {
			console.log(msg);
		});
		socket.on('event', function (msg) {
			console.log('Event receive');
			console.log(msg);
			_EventEmitter2['default'].emit(msg.event, msg.payload);
		});
	} else {
		socket = {
			connected: false,
			legacyBrowser: true
		};
	}
	return socket;
}
//global.socket = initSocket();

/*
 * This silly underscore is here to avoid a mysterious "ReferenceError: ApiClient is not defined" error.
 * See Issue #14. https://github.com/erikras/react-redux-universal-hot-example/issues/14
 *
 * Remove it at your own risk.
 */

var _ApiClient = (function () {
	function _ApiClient() {
		_classCallCheck(this, _ApiClient);
	}

	_ApiClient.prototype.call = function call(method, params, options) {
		if (!params) {
			params = {};
		}
		options = _extends({}, options);
		params._token = '___';
		var transportLayer = undefined;
		/*if (global.socket.connected) {
  	transportLayer = new JsonRpcWS(global.socket);
  }
  else {
  	transportLayer = new JsonRpcAjax('/api');
  }*/
		transportLayer = new _transportJsonrpc2['default']('/api');

		var promise = new _bluebird2['default'](function (resolve, reject) {
			if (options.progress) {
				_reactProgress22['default'].show();
			}
			transportLayer.call(method, params, function (err, data) {
				if (options.progress) {
					_reactProgress22['default'].hide();
				}
				if (err) {
					if (err.code == 500) {
						alert("Nastala vnitřní chyba a server nebyl schopen dokončit Váš požadavek.\nOpakujte akci později.");
					}
					if (err.code == 401) {
						window.location = '/';
					}
					if (err.code == 403) {
						alert("Nemáte oprávnění akci provést.");
					}
					reject(err);
				}
				resolve(data);
			});
		});
		return promise;
	};

	return _ApiClient;
})();

var ApiClient = _ApiClient;
exports['default'] = ApiClient;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/helpers/ApiClient.js
 ** module id = 168
 ** module chunks = 2
 **/